import React, { Component } from 'react';
import qs from 'qs';

import '../../../App.scss';
import { ResendVerificationController } from '../../../components/client/ResendVerificationController';

export default class ClientVerifyEmailScreen extends Component {

  constructor(props) {
    super(props);

    const queryParams = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    const fullPathUrl = new URL(window.location.href);
    const path = '/client/login';
    const host = fullPathUrl.host;
    
    const protocol = window.location.hostname === 'localhost' ? 'http:' : 'https:';

    // Strip null/empty params and clean originParams JSON blob
    if (queryParams.originParams) {
      try {
        const parsed = typeof queryParams.originParams === 'string'
          ? JSON.parse(queryParams.originParams) : queryParams.originParams;
        const cleaned = Object.fromEntries(
          Object.entries(parsed).filter(([, v]) => v != null)
        );
        queryParams.originParams = Object.keys(cleaned).length > 0
          ? JSON.stringify(cleaned) : null;
      } catch (e) { /* leave as-is */ }
    }
    const cleanParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, v]) => v != null && v !== '' && v !== 'null')
    );
    const cleanSearch = qs.stringify(cleanParams, { addPrefix: true, encode: false });
    const url = `${protocol}//${host}${path}${cleanSearch ? `?${cleanSearch}` : ''}`;

    this.state = {
      url,
      queryParams,
      locStrings: {
        terms_and_conditions: "TERMS",
        privacy_policy: "PRIVACY",
        paymentcard2_cashlesstippingtext_46302: "Powered by ",
      }
    };
  }

  async onRefresh() {
    let relativeUrl = '/client/login';
    relativeUrl = `${relativeUrl}${this.props.location.search}`;
    console.log('Refreshing to:', relativeUrl);
    this.props.history.push(relativeUrl);
  }

  render() {
    let layoutFlowStyle = {};
    let baseStyle = {};

    const style_elBackground = {
      width: '100%',
    };
    const style_elBackground_outer = {
      backgroundColor: '#f6f6f6',
    };

    if (this.props.transitionId && this.props.transitionId.length > 0 && this.props.atTopOfScreenStack && this.props.transitionForward) {
      baseStyle.animation = '0.25s ease-in-out ' + this.props.transitionId;
    }
    if (!this.props.atTopOfScreenStack) {
      layoutFlowStyle.overflow = 'hidden';
    }

    const style_elCard_outer = {
      padding: '7.0px',
      borderRadius: '4.0px',
      overflow: 'visible',
    };



    const style_elFooterContainerCard_outer = {
      padding: '4.0px',
      borderRadius: '4.0px',
      overflow: 'visible',
    };

    const style_copyBlock = {
      marginTop: "50px",
      marginBottom: "50px",
    };

    return (
      <div className="AppScreen TagDetailScreen" style={baseStyle}>
        <div className="background">
          <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
            <div className="appBg" style={style_elBackground}>
              <div className="layoutFlow" style={layoutFlowStyle}>
                <div className="flowRow flowRow_TagDetailScreen_elCard_565678">
                  <div className="elCard" style={style_elCard_outer}>
                    <div className="cardBg">



                      <div style={style_copyBlock}>
                        <h1>Please verify your email address</h1>
                        <p>
                          We've sent an email to the address you provided us.
                          <br/><br/>
                          Please click the link in the email to verify your account and continue.
                        </p>
                      </div>

                      <div className="elButton" style={{ textAlign: 'center' }}>
                        <button className="btn btn-primary" onClick={() => this.onRefresh()}>
                          Refresh
                        </button>
                      </div>

                      <div style={{ marginTop: '16px', textAlign: 'center' }}>
                        <ResendVerificationController
                          onVerified={() => this.onRefresh()}
                          url={this.state.url}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
